// src/lib/api/accountApi.ts
//
// Account erasure (GDPR art. 17). Nexilink's own endpoint, NOT the framework's
// DELETE /api/users/me.
//
// The framework route is mounted and looks like the obvious thing to call, but
// it cannot work here: it hard-deletes the users row, Nexilink cascades that
// into candidate_profiles, and job_applications restricts on candidate_profiles
// — so for any candidate who has ever applied for a job it returns 500 and
// changes nothing. It also removes none of the tables that key off user_id
// without a foreign key, including the row pointing at the uploaded CV.
//
// DELETE /api/me/account erases the Nexilink data first and the user last, in
// one transaction. See go.nexilink/services/account_deletion_service.go.

import { getApiClient } from './client';

/**
 * Permanently erases the signed-in candidate and everything belonging to them.
 * Irreversible — there is no soft-delete and no recovery window.
 *
 * Only candidates may do this. Employer and admin accounts are refused with 403
 * (`ACCOUNT_DELETION_ROLE_NOT_ALLOWED`), because deleting one cascades into the
 * organisation's job postings and other people's applications.
 *
 * After this resolves the caller MUST clear the session — the access token is
 * still syntactically valid but every request behind it now 404s.
 */
const deleteOwnAccount = async (): Promise<void> => {
    await getApiClient().delete<void>('/api/me/account');
};

export const accountApi = {
    deleteOwnAccount,
};

export default accountApi;
